import { getIsSyncing, getSyncState } from "../reducers/selectors";
import { useConfigurationRootState } from "./useConfigurationRootState";
export function useSyncInfo() {
    const ecsState = useConfigurationRootState();
    return {
        isSyncing: getIsSyncing(ecsState),
        syncState: getSyncState(ecsState),
    };
}
//# sourceMappingURL=useSyncInfo.js.map